import Api from "@/lib/Api"
import { FavoritePage } from "@/models/menus/menu"

export interface CreateFavoritePagePayload {
    path: string
    title: string
}

export const getFavoritePages = (): Promise<FavoritePage[]> => {
    return Api.get("/admn/favorite_pages/")
}

export const createFavoritePage = (payload: CreateFavoritePagePayload): Promise<FavoritePage> => {
    return Api.post("/admn/favorite_pages/", payload)
}

export const deleteFavoritePage = (id: number): Promise<void> => {
    return Api.delete(`/admn/favorite_pages/${id}/`)
}
